{
    "default": {
        "*": {
            "lineWidth": 2,
            "markerSize": 3
        }
    },
    "map-ts": {
        "mod-*": {
            "lineWidth": 2,
            "markerSize": 4
        }
    },
    "evaluation-ts": {
        "obs-primary": {
            "lineWidth": 2,
            "markerSize": 4,
            "opacity": 1
        },
        "obs-secondary": {
            "lineWidth": 0.5,
            "markerSize": 2,
            "opacity": 0.4
        },
        "mod-primary": {
            "lineWidth": 2,
            "markerSize": 4,
            "opacity": 1
        },
        "mod-secondary": {
            "lineWidth": 0.5,
            "markerSize": 2,
            "opacity": 0.3
        },
        "mod-primary-stdev": {
            "opacity": 0.3
        },
        "mod-secondary-stdev": {
            "opacity": 0.1
        }
    },
    "intercomp-ts": {
        "obs-primary": {
            "lineWidth": 3,
            "markerSize": 4,
            "opacity": 1
        },
        "obs-secondary": {
            "lineWidth": 1,
            "markerSize": 2,
            "opacity": 0.4
        },
        "mod-primary": {
            "lineWidth": 1.25,
            "markerSize": 2,
            "opacity": 1
        },
        "mod-secondary": {
            "lineWidth": 0.75,
            "markerSize": 1,
            "opacity": 0.3
        }
    },
    "overall-ts": {
        "obs": {
            "lineWidth": 2,
            "markerSize": 3,
            "opacity": 1
        },
        "mod": {
            "lineWidth": 1.25,
            "markerSize": 2,
            "opacity": 1
        }
    },
    "frcst-ts": {
        "mod": {
            "lineWidth": 1.25,
            "markerSize": 3,
            "opacity": 1
        }
    }
}